import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import { COLORS } from 'theme';

const DotsIcon = ({ size = '20px', ...props }) => (
  <SvgIcon sx={{ width: size, height: size, ...(props?.sx ?? {}) }} {...props}>
    <path
      d="M11.9995 3C11.4691 3 10.9604 3.21071 10.5853 3.58579C10.2102 3.96086 9.99951 4.46957 9.99951 5C9.99951 5.53043 10.2102 6.03914 10.5853 6.41421C10.9604 6.78929 11.4691 7 11.9995 7C12.5299 7 13.0387 6.78929 13.4137 6.41421C13.7888 6.03914 13.9995 5.53043 13.9995 5C13.9995 4.46957 13.7888 3.96086 13.4137 3.58579C13.0387 3.21071 12.5299 3 11.9995 3ZM11.9995 10C11.4691 10 10.9604 10.2107 10.5853 10.5858C10.2102 10.9609 9.99951 11.4696 9.99951 12C9.99951 12.5304 10.2102 13.0391 10.5853 13.4142C10.9604 13.7893 11.4691 14 11.9995 14C12.5299 14 13.0387 13.7893 13.4137 13.4142C13.7888 13.0391 13.9995 12.5304 13.9995 12C13.9995 11.4696 13.7888 10.9609 13.4137 10.5858C13.0387 10.2107 12.5299 10 11.9995 10ZM11.9995 17C11.4691 17 10.9604 17.2107 10.5853 17.5858C10.2102 17.9609 9.99951 18.4696 9.99951 19C9.99951 19.5304 10.2102 20.0391 10.5853 20.4142C10.9604 20.7893 11.4691 21 11.9995 21C12.5299 21 13.0387 20.7893 13.4137 20.4142C13.7888 20.0391 13.9995 19.5304 13.9995 19C13.9995 18.4696 13.7888 17.9609 13.4137 17.5858C13.0387 17.2107 12.5299 17 11.9995 17Z"
      fill={props.sx?.color || COLORS.kinetikBlack}
    />
  </SvgIcon>
);

DotsIcon.propTypes = {
  size: PropTypes.string,
  sx: PropTypes.object,
};

export default DotsIcon;
